import { reconstructPeaks } from "./reconstructPeaks.js";
/**
 * Build result when no parameters are free to optimize.
 * Computes the fit error using the provided `globalInit` parameter vector
 * and reconstructs the output peak objects from `internalPeaks`.
 * @template T - input Peak type
 * @param internalPeaks - internal representation of peaks (with parameter indices)
 * @param normalizedY - observed Y values normalized by the global scale
 * @param x - X axis values
 * @param globalInit - full parameter vector (actual-space) used to evaluate the model
 * @param baseSumOfShapes - function that returns the spectrum function given parameters
 * @param yScale - the scale factor used to normalize Y (used to reconstruct peak amplitudes)
 * @returns an object containing `error`, `iterations` (0) and the reconstructed `peaks`
 */
export function getFixedParametersResult(internalPeaks, normalizedY, x, globalInit, baseSumOfShapes, yScale) {
    const fct = baseSumOfShapes(globalInit);
    let error = 0;
    for (let i = 0; i < normalizedY.length; i++) {
        error += (normalizedY[i] - fct(x[i])) ** 2;
    }
    return {
        error,
        iterations: 0,
        peaks: reconstructPeaks(internalPeaks, globalInit, yScale),
    };
}
//# sourceMappingURL=getFixedParametersResult.js.map